import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockClicks } from "lib/@components/block-clicks"
import { createDraft } from "controller/create-draft-schedule"
import { OpenDraft } from "event-definitions"
import { uniqueId } from "library/database/split-id.mjs"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"

export function CreateDraft() {
    const { target } = useBoundContext()
    return (
        <BlockClicks>
            <ContextMenuItem
                icon="clarity:edit-solid"
                label="Create Draft"
                onClick={create}
                data-cy="create-draft-menu-item"
            />
        </BlockClicks>
    )

    async function create() {
        await createDraft(target._id)
        OpenDraft(uniqueId(target._id)).raise(`allDrafts!${uniqueId(target._id)}`)
    }
}
